export const BASE_URL = "https://store.bst-inn.com/dashbord/"